import { letters, mainInput, mainText } from "../../index";
import santaTalking from "../data/santaTalking";
import { increaseCounter, questionCounter } from "./checkResult";
import displayLetter from "./displayLetter";

let waitingForKeypress = false;
let isFinished = false;
function displaySantaTalk(){
  if ( questionCounter < 8 ) {
    mainInput.style.display= 'none';
    mainText.textContent= santaTalking[questionCounter-1].sentence;
    waitingForKeypress = true;
    document.addEventListener( 'keydown' , e => {
      if ( waitingForKeypress === true ) {
        switch ( e.key ) {
          case 'l':
            displayLetter(0);
            break;
          case 'a':
            displayLetter(1);
            break;
          case 'u':
            displayLetter(2);
            break;
          case 'r':
            displayLetter(3);
            break;
          case 'e':
            displayLetter(4, 7);
            break;
          case 'n':
            displayLetter(5);
            break;
          case 'c':
            displayLetter(6);
            break;
          default:
            displayLetter();
            break;
        }
        waitingForKeypress = false;
      }
    });
  } else if ( questionCounter === 8 ) {
    mainText.textContent= santaTalking[questionCounter-1].sentence;
    waitingForKeypress = false;
    mainInput.style.display= 'none';
    document.addEventListener( 'keydown' , () => {
      if ( isFinished === false ) { 
        displaySantaTalk();
        increaseCounter();
      }
    });
  } else if ( questionCounter === 9 ) {
    mainText.textContent= santaTalking[questionCounter-1].sentence;
    letters.forEach( item => {
      item.style.display= 'none';
    })
  } else {
    mainText.textContent= santaTalking[questionCounter-1].sentence;
    isFinished = true;
  }
}

export default displaySantaTalk;